/**
 * PortalLayout - 门户布局组件
 * 与 AdminLayout 共用 BaseLayout（Header + 退出登录弹窗）
 * Body 区域直接渲染 children，不包含 Sidebar
 */
import BaseLayout from './BaseLayout';

interface PortalLayoutProps {
  children: React.ReactNode;
}

export default function PortalLayout({ children }: PortalLayoutProps) {
  return (
    <BaseLayout>
      <div className="flex-1 min-h-0" style={{position:'relative',zIndex:1}}>
        {children}
      </div>
    </BaseLayout>
  );
}
